import React from 'react';
import DOMPurify from 'dompurify';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';

export const CampaignPreviewDialog = ({ 
  open, 
  onOpenChange, 
  campaign,
  getStatusBadge 
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="font-heading">Campaign Preview</DialogTitle>
        </DialogHeader>
        {campaign && (
          <div className="space-y-4">
            <div>
              <Label className="text-slate-500">Campaign Name</Label>
              <p className="font-medium text-slate-900">{campaign.name}</p>
            </div>
            <div>
              <Label className="text-slate-500">Subject</Label>
              <p className="font-medium text-slate-900">{campaign.template?.subject}</p>
            </div>
            <div>
              <Label className="text-slate-500">Email Body</Label>
              <div 
                className="mt-2 p-4 bg-slate-50 rounded-md border border-slate-200 prose prose-sm max-w-none"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(campaign.template?.body || '') }}
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label className="text-slate-500">Recipients</Label>
                <p className="font-medium text-slate-900">{campaign.contact_ids?.length || 0}</p>
              </div>
              <div>
                <Label className="text-slate-500">Status</Label>
                <div className="mt-1">{getStatusBadge(campaign.status, campaign.scheduled_at)}</div>
              </div>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default CampaignPreviewDialog;
